import { useParams } from "react-router-dom";
import { useGetPatientDetails } from "../apis/patients";
import DesktopHeader from "../components/defaultHeader/DesktopHeader";
import {
  Box,
  Flex,
  Heading,
  Tab,
  TabIndicator,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
  useBreakpointValue,
} from "@chakra-ui/react";
import colors from "../utils/colors";
import PatientCard from "../features/patients/components/PatientCard";
import PatientDemographic from "../features/patients/components/PatientDemographic";
import moment from "moment";
import PatientOverview from "../features/patients/components/PatientOverview";
import PatientAppointment from "../features/patients/components/PatientAppointment";

const PatientPage = () => {
  const { id } = useParams();
  const { data, error, isLoading } = useGetPatientDetails({
    patientId: id as string,
  });

  const appointmentId = data?.data?.appointments[0]?.id || "Default ID";

  const isMobile = useBreakpointValue({ base: true, md: false });

  return (
    <>
      <DesktopHeader
        headerContent={
          <Flex
            direction={{ base: "column", sm: "row" }}
            align={{ base: "flex-start", sm: "center" }}
            gap="8px"
          >
            <Heading color={colors.grey} fontSize={{ base: "md", md: "lg" }}>
              Patients
            </Heading>
            <Heading color={colors.grey} fontSize={{ base: "md", md: "lg" }}>
              &gt;
            </Heading>
            <Heading fontSize={{ base: "md", md: "lg" }}>
              {data?.data?.name}
            </Heading>
          </Flex>
        }
      />

      <Box
        px={{ base: "16px", md: "30px" }}
        py={{ base: "20px", md: "30px" }}
        w="full"
        minH="100vh"
        bg={colors.lightGrey}
      >
        <Flex
          direction={{ base: "column", md: "row" }}
          gap="20px"
          align="stretch"
        >
          <PatientCard
            patient={{
              id: data?.data?.patientId,
              name: data?.data?.name,
              risk: data?.data?.riskCategory,
            }}
          />
          <PatientDemographic
            patient={{
              dob: moment(data?.data?.dateOfBirth).format("MMM DD, YYYY"),
              gender: data?.data?.gender,
              email: data?.data?.email,
              bloodGroup: data?.data?.bloodGroup,
              genotype: data?.data?.bloodGenotype,
              height: data?.data?.height,
              weight: data?.data?.weight,
              date: moment(data?.data?.dateRegistered)?.format("DD MMM YYYY"),
              address: data?.data?.address,
              phone: data?.data?.phoneNumber,
            }}
          />
        </Flex>

        <Tabs
          mt={{ base: "30px", md: "50px" }}
          fontFamily="lato"
          variant="unstyled"
        >
          <TabList
            mb="20px"
            display="flex"
            flexWrap={{ base: "wrap", md: "nowrap" }}
            gap={{ base: "8px", md: "0" }}
          >
            <Tab
              fontWeight={400}
              fontSize={{ base: "sm", md: "18px" }}
              letterSpacing="0.5px"
              color={colors.placeholderColor}
              _selected={{
                color: colors.primary,
                fontWeight: 700,
                fontSize: { base: "sm", md: "18px" },
                px: "8px",
              }}
            >
              Overview
            </Tab>
            <Tab
              fontWeight={400}
              fontSize={{ base: "sm", md: "18px" }}
              letterSpacing="0.5px"
              color={colors.placeholderColor}
              _selected={{
                color: colors.primary,
                fontWeight: 700,
                fontSize: { base: "sm", md: "18px" },
                px: "8px",
              }}
            >
              Appointments
            </Tab>
          </TabList>

          <TabIndicator
            mt="-15px"
            height="2px"
            bg={colors.primary}
            borderRadius="1px"
          />

          <TabPanels>
            <TabPanel px="0">
              <PatientOverview appointmentId={appointmentId} />
            </TabPanel>
            <TabPanel px="0">
              <PatientAppointment />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </>
  );
};

export default PatientPage;
